module.exports = __webpack_public_path__ + "img/default-tall.11a64441.jpg";